<ng-template ngbPaginationPrevious let-disabled="disabled">
  <app-button
    class="link-button"
    buttonType="primary"
    styleType="contained"
    shapeType="square"
    icon="assets/icons/chevron-left.svg"
    [disabled]="!!disabled"
  ></app-button>
</ng-template>
<ng-template ngbPaginationNumber let-page>
  <app-button
    class="link-button"
    [buttonType]="currentPage === page ? 'primary' : 'normal'"
    styleType="contained"
    shapeType="square"
    text="{{ page }}"
  ></app-button>
</ng-template>
<ng-template ngbPaginationNext let-disabled="disabled">
  <app-button
    class="link-button"
    buttonType="primary"
    styleType="contained"
    shapeType="square"
    icon="assets/icons/chevron-right.svg"
    [disabled]="!!disabled"
  ></app-button
></ng-template>

<ng-template #first><span aria-hidden="true">&laquo;&laquo;</span></ng-template>
<ng-template #last><span aria-hidden="true">&raquo;&raquo;</span></ng-template>
<ng-template #ellipsis>...</ng-template>
<ng-template #defaultPages let-page let-pages="pages" let-disabled="disabled">
  <li
    *ngFor="let pageNumber of pages"
    class="page-item"
    [class.active]="pageNumber === page"
    [class.disabled]="isEllipsis(pageNumber) || disabled"
    [attr.aria-current]="pageNumber === page ? 'page' : null"
  >
    <a
      *ngIf="isEllipsis(pageNumber)"
      class="page-link"
      tabindex="-1"
      aria-disabled="true"
    >
      <ng-template [ngTemplateOutlet]="ellipsis"></ng-template>
    </a>
    <a
      *ngIf="!isEllipsis(pageNumber)"
      class="page-link"
      href
      (click)="selectPage(pageNumber); $event.preventDefault()"
      [attr.tabindex]="disabled ? '-1' : null"
      [attr.aria-disabled]="disabled ? 'true' : null"
    >
      <ng-template
        [ngTemplateOutlet]="tplNumber?.templateRef"
        [ngTemplateOutletContext]="{
          disabled: disabled,
          $implicit: pageNumber,
          currentPage: page
        }"
      ></ng-template>
    </a>
  </li>
</ng-template>

<div class="row gx-0">
  <div class="col-auto">
    <ul [class]="'pagination' + (size ? ' pagination-' + size : '')">
      <li
        *ngIf="boundaryLinks"
        class="page-item"
        [class.disabled]="previousDisabled()"
      >
        <a
          aria-label="First"
          class="page-link"
          href
          (click)="selectPage(1); $event.preventDefault()"
          [attr.tabindex]="previousDisabled() ? '-1' : null"
          [attr.aria-disabled]="previousDisabled() ? 'true' : null"
        >
          <ng-template
            [ngTemplateOutlet]="tplFirst?.templateRef || first"
            [ngTemplateOutletContext]="{
              disabled: previousDisabled(),
              currentPage: page
            }"
          ></ng-template>
        </a>
      </li>
      <li
        *ngIf="directionLinks"
        class="page-item"
        [class.disabled]="previousDisabled()"
      >
        <a
          aria-label="Previous"
          class="page-link"
          href
          (click)="selectPage(page - 1); $event.preventDefault()"
          [attr.tabindex]="previousDisabled() ? '-1' : null"
          [attr.aria-disabled]="previousDisabled() ? 'true' : null"
        >
          <ng-template
            [ngTemplateOutlet]="tplPrevious?.templateRef"
            [ngTemplateOutletContext]="{ disabled: previousDisabled() }"
          ></ng-template>
        </a>
      </li>
      <ng-template
        [ngTemplateOutlet]="defaultPages"
        [ngTemplateOutletContext]="{
          $implicit: page,
          pages: pages,
          disabled: disabled
        }"
      >
      </ng-template>
      <li
        *ngIf="directionLinks"
        class="page-item"
        [class.disabled]="nextDisabled()"
      >
        <a
          aria-label="Next"
          class="page-link"
          href
          (click)="selectPage(page + 1); $event.preventDefault()"
          [attr.tabindex]="nextDisabled() ? '-1' : null"
          [attr.aria-disabled]="nextDisabled() ? 'true' : null"
        >
          <ng-template
            [ngTemplateOutlet]="tplNext?.templateRef"
            [ngTemplateOutletContext]="{
              disabled: nextDisabled(),
              currentPage: page
            }"
          ></ng-template>
        </a>
      </li>
      <li
        *ngIf="boundaryLinks"
        class="page-item"
        [class.disabled]="nextDisabled()"
      >
        <a
          aria-label="Last"
          class="page-link"
          href
          (click)="selectPage(pageCount); $event.preventDefault()"
          [attr.tabindex]="nextDisabled() ? '-1' : null"
          [attr.aria-disabled]="nextDisabled() ? 'true' : null"
        >
          <ng-template
            [ngTemplateOutlet]="tplLast?.templateRef || last"
            [ngTemplateOutletContext]="{
              disabled: nextDisabled(),
              currentPage: page
            }"
          ></ng-template>
        </a>
      </li>
    </ul>
  </div>

  <div class="col-auto">
    <p *ngIf="totalCount" class="page-total-items">
      <ng-template
        [ngTemplateOutlet]="tplText?.templateRef ?? defaultTotalCountTextTpl"
        [ngTemplateOutletContext]="{totalCount, pageSize, pageIndex, currentPage}"
      ></ng-template>
    </p>
  </div>
</div>

<ng-template #defaultTotalCountTextTpl>
  Total: {{ totalCount | number }}
</ng-template>
